import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xZzN1Nzd1MCB7CiAgZGlzcGxheTogYmxvY2s7Cn0';
export var textAreaOverridesClass = '_1g3u77u0';